import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const Legal = () => {
  return (
    <div>
      <Navbar/>
      Legal
      <Footer/>
    </div>
  )
}

export default Legal
